import Swal from "sweetalert2";

export const alertToastSucess = (colorMode: string) => {
    Swal.fire({
        title: 'Your file has been deleted.',
        toast: true,
        icon: 'success',
        timer: 1500,
        iconColor: 'Green',
        timerProgressBar: true,
        showConfirmButton: false,
        customClass: {
          popup: `colored-toast-${colorMode}`
        },
      });
};

export const alertToastWarning = (colorMode: string) => {
  return Swal.fire({
    title: "Write something on the box",
    toast: true,
    icon: "warning",
    timer: 1500,
    iconColor: "crimson",
    timerProgressBar: true,
    showConfirmButton: false,
    customClass: {
      popup: `colored-toast-${colorMode}`,
    },
  });
};


export const confirmDelete = async (colorMode:string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'Green',
      cancelButtonColor: 'Crimson',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      iconColor: 'crimson',
      customClass: {
        popup: `colored-toast-${colorMode}`
      },
    });
    return result;
  }
